import { render, staticRenderFns } from "./EqsClickableCard.vue?vue&type=template&id=196df88f"
import script from "./EqsClickableCard.vue?vue&type=script&lang=js"
export * from "./EqsClickableCard.vue?vue&type=script&lang=js"
import style0 from "./EqsClickableCard.vue?vue&type=style&index=0&id=196df88f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports